partner
<template>
  <Content title="2000+企业的肯定">
    <div id="affirm-item-logo-container" class="flex-nowrap d-flex" data-interval="false">
      <template v-for="i in 2" :key="i">
        <img
          v-for="index in 12"
          :key="index"
          width="238"
          class="affirm-item-logo"
          :src="`/images/pages/tmc/affirm-${index >= 10 ? index : '0' + index}.png`"
        />
      </template>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { onMounted, onUnmounted } from '@vue/runtime-core'
export default {
  name: 'DesktopAffirm',
  components: { Content },
  setup() {
    let interval

    onMounted(() => {
      // 跑马灯效果
      const el = document.getElementById('affirm-item-logo-container')
      const width = [...el.children].reduce((pre, cur) => pre + cur.offsetWidth, 0)
      let distance = 0
      interval = setInterval(() => {
        distance = distance > width / 2 ? 0 : distance + 1
        el.scrollTo({ left: distance, behavior: 'auto' })
      }, 20)
    })

    onUnmounted(() => {
      clearInterval(interval)
    })
  },
}
</script>

<style lang="scss" scoped>
#affirm-item-logo-container {
  overflow-x: scroll;
}

#affirm-item-logo-container::-webkit-scrollbar {
  display: none;
}

.affirm-item-logo {
  width: 238px;
  height: 121px;
  flex-shrink: 0;
  flex-basis: 238px;
}
</style>
